import { IImageTransform, StretchOptionType } from './image-layer';
import { ILinearGradient } from './vector-layer';

/** 画笔类型 */
export enum BrushType {
    /**
     * 通过代码直接绘制, 描边添加在 svg 本身路径上
     */
    /** 方形 */
    Rect = 'rect',
    /** 椭圆 */
    Ellipse = 'ellipse',

    /**
     * 线条笔，通过生成ForeignObject，描边通过 canvas 绘制
     */
    /** 直线 */
    Line = 'line',
    /** 曲线 */
    Curve = 'curve',

    /**
     * 箭头笔，通过拼接 svg 来实现端点
     */
    /** 箭头 */
    Arrow = 'arrow',

    /**
     * 多边形，通过生成ForeignObject，描边添加在 svg 本身路径上
     */
    /** 多边形，星形，三角形边形 */
    Polygon = 'polygon',

    /**
     * 波浪线，通过重复路径的第2个字母到结尾来绘制
     * 示例：M1.7,5.6c34.9,0,34.9,55.9,69.8,55.9s34.9-55.9,69.8-55.9
     * 重复：c34.9,0,34.9,55.9,69.8,55.9s34.9-55.9,69.8-55.9
     */
    /** 波浪线 */
    Wavy = 'wavy',
}

/** 画笔端点形状 */
export enum BrushLinecapType {
    /** 方形 */
    Square = 'square',
    /** 圆形 */
    Round = 'round',
}

/** 样式 */
export enum BrushDasharrayType {
    /** 实线 */
    Solid = '',
    /** 方形虚线 */
    Square = '3,2',
    /** 圆点虚线 */
    Dot = '0,2',
    /** 间隔虚线 */
    Dashed = '2,2,6,2',
}

/** 画笔描边 */
export interface IBrushAttribute {
    /** 颜色 */
    color: string | ILinearGradient;
    /** 样式 */
    dasharray: BrushDasharrayType;
    /** 样式-形状 */
    linecap: BrushLinecapType;
    /** 粗细 */
    width: number;
    /** 偏移量X */
    offsetX: number;
    /** 偏移量 Y */
    offsetY: number;
}

/** 端点类型 */
export enum BrushPointType {
    /** 空类型 */
    None = '',
    /** 直线箭头 */
    StraightArrow = 'StraightArrow',
    /** 弧形箭头 */
    CurvedArrow = 'CurvedArrow',
    /** 半箭头 */
    HalfArrow = 'HalfArrow',
    /** 竖形 */
    VerticalShape = 'VerticalShape',
    /** 实心三角形 */
    SolidTriangle = 'SolidTriangle',
    /** 实心圆 */
    SolidCircle = 'SolidCircle',
    /** 镂空矩形 */
    HollowRect = 'HollowRect',
}

/** 画笔端点 */
export interface IBrushPoint {
    /** 素材地址 */
    url: string;
    /** 端点类型 */
    type: BrushPointType;
    /** 4px,端点直线偏移量 */
    offset: number;
    /** 4px,图像宽 */
    width: number;
    /** 4px,图像高 */
    height: number;
}

/** 画笔配置 */
export interface IBrushDrawConfig {
    /** 画笔类型 */
    brushType: BrushType;
    /** 画笔素材地址 */
    url: string;

    /** 填充 */
    fills: IBrushAttribute[];
    /** 描边 */
    stroke: IBrushAttribute;

    /** 箭头笔-线始端样式 */
    startPoint: IBrushPoint;
    /** 箭头笔-线末端样式 */
    endPoint: IBrushPoint;

    /** 矩形-圆角 */
    radius: number;

    /** vip 标记，不写入配方 */
    __vipFuncType?: string;
    /** 是否自定义属性，自定属性不需要对配方进行等比缩放，画笔基准：1242px */
    __custom?: boolean;
    /** 是否是快捷键绘制 */
    __isQuickDraw?: boolean;
}

export type BrushData = IBrushDrawConfig & {
    naturalWidth: number;
    naturalHeight: number;
};

export interface IBrushLayerProps extends IBrushDrawConfig {
    /** 变换参数，裁剪，翻转 */
    imageTransform: IImageTransform;
    /** 渲染图层方式 */
    stretchOption: StretchOptionType;

    /** 图形宽 */
    naturalWidth: number;
    /** 图形高 */
    naturalHeight: number;

    /** 结果图 */
    screenshotUrl?: string | null;

    /** 绘制时候的实时路径，配方里不会存在该字段 */
    __drawPath?: string;
    /** 绘制预览，配方里不会存在该字段 */
    __isDrawPreview?: boolean;
}
